var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPuzzlePieces(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_4401",
    "data-name": "Group 4401",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3582",
    "data-name": "Rectangle 3582",
    width: 36,
    height: 36,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4401-2",
    "data-name": "Group 4401",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3959",
    "data-name": "Path 3959",
    d: "M15.417,17.71a2.542,2.542,0,0,0-.8,1.357.3.3,0,0,1-.5.14l-3.571-3.572L7,19.179a.287.287,0,0,0,.135.481,2.552,2.552,0,1,1-3.114,3.11.286.286,0,0,0-.48-.133L0,26.182,10.547,36.728l3.544-3.544a.288.288,0,0,0-.135-.481,2.552,2.552,0,1,1,3.115-3.11.286.286,0,0,0,.48.133l3.544-3.544-3.571-3.572a.3.3,0,0,1,.142-.5,2.552,2.552,0,1,0-2.247-4.4",
    transform: "translate(0 -0.728)",
    fill: "#527991"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3960",
    "data-name": "Path 3960",
    d: "M28.333,4.793a2.549,2.549,0,0,1,1.258-.768.287.287,0,0,0,.135-.481L26.182,0l-3.56,3.56a.294.294,0,0,1-.495-.136,2.552,2.552,0,1,0-3.071,3.067.3.3,0,0,1,.139.5l-3.56,3.56,3.544,3.544a.287.287,0,0,0,.481-.135A2.552,2.552,0,1,1,22.77,17.07a.286.286,0,0,0-.133.48l3.544,3.544L36.728,10.547,33.185,7a.286.286,0,0,0-.48.133,2.552,2.552,0,1,1-4.372-2.343",
    transform: "translate(-0.728 0)",
    fill: "#527991"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPuzzlePieces);
export default __webpack_public_path__ + "static/media/puzzlePieces.c75e9c3d.svg";
export { ForwardRef as ReactComponent };